<template>
    <div
        aria-hidden="true"
        aria-labelledby="modalFillInLabel"
        :class="classes"
        :id="'modal-'+id"
        role="dialog"
        tabindex="-1"
        :data-backdrop="disableOutsideClick ? 'static' : null"
    >
        <div class="v-modal-dialog">
            <div class="v-modal-content">
                <header class="v-modal-header" :class="{'v-modal-header--fixed': hasFooter }" v-if="hasHeader">
                    <slot name="header"></slot>

                    <button v-if="!noClose" aria-hidden="true" class="v-modal-header__close" data-dismiss="modal" type="button" @click="close()">
                        <span class="material-symbols-rounded">close</span>
                    </button>
                </header>

                <div class="v-modal-body">
                    <slot name="content"></slot>
                </div>

                <footer class="v-modal-footer" v-if="hasFooter">
                    <slot name="footer"></slot>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            default: 'default',
            validator: function (value) {
                return ['default', 'video'].indexOf(value) !== -1;
            },
        },
        isActive: {
            type: Boolean,
            default: false
        },
        contentFullWidth: {
            type: Boolean,
            default: false
        },
        noClose: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'md',
            validator: function (value) {
                return ['sm', 'md', 'lg'].indexOf(value) !== -1;
            },
        },
        position: {
            type: String,
            default: 'center',
            validator: function (value) {
                return ['center', 'bottom-right'].indexOf(value) !== -1;
            },
        },
        disableOutsideClick: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
        }
    },
    computed: {
        classes() {
            return {
                'v-modal': true,
                [`v-modal--default`]: this.type === 'video',
                [`v-modal--${this.type}`]: true,
                [`v-modal--${this.size}`]: true,
                [`v-modal--${this.position}`]: true,
            };
        },
        hasFooter() {
            return this.$slots.footer
        },
        hasHeader() {
            return this.$slots.header || (!this.$slots.header && !this.noClose)
        }
    },
    mounted() {
        if(this.isActive) {
            $(`#modal-${this.id}`).modal('show')
        }
    },
    methods: {
        close() {
            this.$emit("onClose")
        }
    },
}
</script>
